import { useEffect } from 'react';

/**
 * A hook to handle tab selection and view's value update in URL
 * @param {string} pathname
 * @param {string} view
 * @param {string} activeTab
 * @param {function} setActiveTab
 * @param {object} tabs
 * @param {function} navigate
 * @returns {void}
 */
const useTabManager = ({ pathname, view, viewDetails = undefined, activeTab, setActiveTab, tabs, navigate }) => {
    // Handles tab selection
    useEffect(() => {
        const search = viewDetails ? `?view=${view}&viewDetails=${activeTab}` : `?view=${activeTab}`;
        navigate({
            pathname: pathname,
            search: search
        });
    }, [activeTab]);

    // Handles view's value update in URL
    useEffect(() => {
        if (viewDetails && viewDetails !== activeTab) {
            const nextActiveTab = Object.values(tabs).find(tab => tab.name === viewDetails)?.name ?? tabs.DEFAULT.name;
            setActiveTab(nextActiveTab);
        }
        if (!viewDetails && view !== activeTab) {
            const nextActiveTab = Object.values(tabs).find(tab => tab.name === view)?.name ?? tabs.DEFAULT.name;
            setActiveTab(nextActiveTab);
        }
    }, [view, viewDetails]);
};

export default useTabManager;